import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicServerReimageParamsRaw,
	LWApiPublicServerReimageResultRaw,
} from '@liquidweb-dev/club-sauce/public/server/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { ASSET_DETAILS_OUERY_KEY } from 'modules/queries/asset/useDetails';
import { NOTIFICATIONS_CURRENT_QUERY_KEY } from 'modules/queries/notification/useCurrent';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useServerReimage = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicServerReimageResultRaw,
		ApiErrorI,
		LWApiPublicServerReimageParamsRaw
	>({
		mutationFn: (params) => api.server.apiRaw.reimage(params),

		onError: snackbarError,

		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: [
					ASSET_DETAILS_OUERY_KEY,
					{
						uniq_id: data.uniq_id,
					},
				],
			});

			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_CURRENT_QUERY_KEY],
			});
		},
	});
};

export default useServerReimage;
